import "./WidgetFileItem.css"
import { ReactComponent as File_NoType_Icon } from "../../../../files/system/File_NoType_Icon.svg";
import { ReactComponent as File_Excel_Icon } from "../../../../files/system/File_Excel_Icon.svg";
import { ReactComponent as File_World_Icon } from "../../../../files/system/File_World_Icon.svg";
import { ReactComponent as File_Pdf_Icon } from "../../../../files/system/File_Pdf_Icon.svg";
import { ReactComponent as File_Video_Icon } from "../../../../files/system/File_Video_Icon.svg";
import { ReactComponent as File_Photo_Icon } from "../../../../files/system/File_Photo_Icon.svg";
import { ReactComponent as File_Music_Icon } from "../../../../files/system/File_Music_Icon.svg";
import { ReactComponent as File_Archive_Icon } from "../../../../files/system/File_Archive_Icon.svg";

function WidgetFileItem({ model, idObject }) {

    /*
        model:
            ID_Board_Task 
            Widget_Number 
            ID_File 
            ID_Type 
            Name 
            Path 
            Order 
            Size

    idObject:
        1	Задача
        2	Регулярная задача
        6   Регулярная задача. Трекер
        3	Доска
        4	Проект
        5	Пользователь
    */
    /*
    ID_Type:
            ID	Name
            0	Не определено
            1	Видео +
            2	Фото +
            3	Музыка +
            4	Excel + 
            5	Word +
            6	Pdf +
            7	Архив
    */
    function linkGet() {
        if (idObject === 1) {
            return 'https://api.tracker.biz-office.ru/task/widgetFileDownload?ID_File=' + model.ID_File;
        }
        if (idObject === 2 || idObject === 6) {
            return 'https://api.tracker.biz-office.ru/taskR/widgetFileDownload?ID_File=' + model.ID_File;
        }
        if (idObject === 3) {
            return 'https://api.tracker.biz-office.ru/board/taskWidgetFileDownload?ID_File=' + model.ID_File;
        }
    }
    /*
    0	Не определено
    1	Видео
    2	Фото
    3	Музыка
    4	Excel
    5	Word
    6	Pdf
    7	Архив
    */
    return (
        <div className="file_row">
            <div>
                {model.ID_Type === 0 && (<File_NoType_Icon className="file_row_icon" />)}
                {model.ID_Type === 1 && (<File_Video_Icon className="file_row_icon" />)}
                {model.ID_Type === 2 && (<File_Photo_Icon className="file_row_icon" />)}
                {model.ID_Type === 3 && (<File_Music_Icon className="file_row_icon" />)}
                {model.ID_Type === 4 && (<File_Excel_Icon className="file_row_icon" />)}
                {model.ID_Type === 5 && (<File_World_Icon className="file_row_icon" />)}
                {model.ID_Type === 6 && (<File_Pdf_Icon className="file_row_icon" />)}
                {model.ID_Type === 7 && (<File_Archive_Icon className="file_row_icon" />)}
            </div>

            <a href={linkGet()} className="file_row_text">{model.Name}</a>
        </div>
    )
}

export default WidgetFileItem;